export const LOGIN_ERROR = 'Ошибка логина';
